import moment from "moment";
export const formatTime = (time, type) => {
  switch (type) {
    case "monthDay":
      return moment(time).format("MM.DD");
    case "normal":
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    case "yearMonthDay":
      return moment(time).format("YYYY-MM-DD");
  }
};
